export default __webpack_public_path__ + "static/media/image2.42d74ed0.jpeg";